import { isProd } from '@core/Utils/App/IsProd';

type MissingKenticoContentProps = {
  identifier: string;
  contentType?: string;
};

export const MissingKenticoContent = ({ identifier, contentType }: MissingKenticoContentProps) => {
  if (isProd) return null;

  return (
    <p style={{ color: 'red' }}>
      <strong>
        Missing Content: {identifier}
        {contentType ? ` (${contentType})` : ''}
      </strong>
    </p>
  );
};
